import * as VueGoogleMaps from 'vue2-google-maps'
// import gmapCluster from 'vue2-google-maps/dist/components/cluster'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBFQCkPCRWZ0uPxmpPd4eUL-bGgRUWUiHw'
    },
    installComponents: false,
})

Vue.component('mapWrapper', {
    components: {
        // gmapCluster,
        googleMap: VueGoogleMaps.Map,
        googleMarker: VueGoogleMaps.Marker,
        googleInfoWindow: VueGoogleMaps.InfoWindow
    },
    props: {
        mapCenter: ""
    },
    data() {
        return {
            options: {
                styles: [{
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#e9e9e9"
                    }, {
                        "lightness": 17
                    }]
                }, {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#f5f5f5"
                    }, {
                        "lightness": 20
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#ffffff"
                    }, {
                        "lightness": 17
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [{
                        "color": "#ffffff"
                    }, {
                        "lightness": 29
                    }, {
                        "weight": 0.2
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#ffffff"
                    }, {
                        "lightness": 18
                    }]
                }, {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#ffffff"
                    }, {
                        "lightness": 16
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#f5f5f5"
                    }, {
                        "lightness": 21
                    }]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#dedede"
                    }, {
                        "lightness": 21
                    }]
                }, {
                    "elementType": "labels.text.stroke",
                    "stylers": [{
                        "visibility": "on"
                    }, {
                        "color": "#ffffff"
                    }, {
                        "lightness": 16
                    }]
                }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "saturation": 36
                    }, {
                        "color": "#333333"
                    }, {
                        "lightness": 40
                    }]
                }, {
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#f2f2f2"
                    }, {
                        "lightness": 19
                    }]
                }, {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#fefefe"
                    }, {
                        "lightness": 20
                    }]
                }, {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [{
                        "color": "#fefefe"
                    }, {
                        "lightness": 17
                    }, {
                        "weight": 1.2
                    }]
                }],
                // gestureHandling: "greedy",
                scrollwheel: false
            },
            icon: {
                url: '/public/site/moratispassas/dist/img/pin.svg',
                // size: {width: 46, height: 46, f: 'px', b: 'px'},
                scaledSize: {
                    width: 24,
                    height: 35,
                    f: 'px',
                    b: 'px'
                }
            },
            infoWinOpen: false,
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -30
                }
            },
            infoContent: {
                title: null,
                descr: null,
                address: null
            },
            infoWindowPos: null,
            currentMidx: null,
            clusterStyles: [{
                textColor: '#fff',
                url: '/public/site/latsco/dist/img/cluster.png',
                height: 50,
                width: 50
            }]
        }
    },
    methods: {
        toggleInfoWindow: function (position, content, idx) {

            // this.mapCenter = position

            this.infoWindowPos = position;
            this.infoContent = content

            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
                this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
                this.infoWinOpen = true;
                this.currentMidx = idx;
            }
        }
    },
})


// WEBPACK FOOTER //
// ./src/js/map.js